var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('transition',{attrs:{"name":"message"}},[_c('div',{staticClass:"product-message"},[_vm._v(_vm._s(_vm.websiteText('productpage.article.product.added.notice')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }